/**
 * usePageTracking - Fires page_view to GTM + Meta Pixel on route changes
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService, trackEvent } from '../services/analyticsService';

/**
 * Call once in App to track page views on every route change.
 * Only sends events after the user has consented (GTM is initialized).
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (!analyticsService.isInitialized()) {
      return;
    }
    trackEvent('page_view', {
      page_path: location.pathname,
      page_title: typeof document !== 'undefined' ? document.title : '',
      page_location: typeof window !== 'undefined' ? window.location.href : ''
    });
  }, [location.pathname]);
}

export default usePageTracking;
